import TableCard from "../../components/TableCard";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import {
  buscarFaturamentosPorGrupoEconomico,
  obterFaturasPorCampo,
} from "../../services/api-financeiro.service";
import { useEffect, useState } from "react";
import SnackBar from "../../components/SnackBar";
import { formatValue } from "../../utils/formatValue";
import styles from "./styles.module.css";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import ToolBar from "../../components/ToolBar";
import GenericDatePicker from "../../components/GenericDatePicker";
import BtnExtratorRelatorio from "./BtnExtratorRelatorio";
import DescriptionIcon from "@mui/icons-material/Description";
import ChatAssincrono from "../../components/ChatAssincrono";

const Faturamento = () => {
  const initialStategpEEmpresa = {
    grupoSelecionado: null,
    empresasSelecionadas: [],
  };

  const inicialStateBtnFilter = {
    icon: <FilterAltIcon />,
    label: "Filtrar",
  };

  const inicialStateDateFilter = {
    dtInicial: null,
    dtFinal: null,
  };

  const [loading, setLoading] = useState(false);
  const [gpEEmpresa, setGrupoEEmpresa] = useState(initialStategpEEmpresa);
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });
  const [dateFilterInput, setDateFilterInput] = useState(
    inicialStateDateFilter
  );

  const [dataPdf, setDataPdf] = useState([]);
  const [filterBtn, setFilterBtn] = useState(inicialStateBtnFilter);

  const handleSnackBar = (obj) => {
    setObjSnackBar(obj);
  };

  const columns = [
    "CNPJ",
    "Serviço",
    "Dt. Fatura",
    "Percentual Honorários",
    "Imposto",
    "Vl. Fatura",
    "Vl. Final Horário",
    "Valor IR",
    "Pis/Cofins",
    "Vl. Csll",
    "Boleto",
    "Histórico Fatura",
  ];

  const getData = async (idGrupoEconomico) => {
    setLoading(true);
    try {
      const response = await buscarFaturamentosPorGrupoEconomico(
        idGrupoEconomico
      );

      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setObjSnackBar({ type: "error", msg: error.mensagem });
    }
  };

  const handleFiltrarPorData = (value, name) => {
    switch (name) {
      case "inicial":
        setDateFilterInput({ ...dateFilterInput, dtInicial: value });
        break;
      case "final":
        setDateFilterInput({ ...dateFilterInput, dtFinal: value });
        break;

      default:
        console.log(value);
        break;
    }
  };

  const handleDebounce = async (value) => {
    if (gpEEmpresa.grupoSelecionado) {
      if (value) {
        try {
          const response = await obterFaturasPorCampo(
            value,
            gpEEmpresa.grupoSelecionado
          );

          const cnpjFormatado = gpEEmpresa.empresasSelecionadas.map((item) =>
            item.replace(/[^\d]/g, "")
          );

          const responseFilter = response.faturamentos.filter((item) =>
            cnpjFormatado.some((cnpj) => cnpj === item.cnpj)
          );

          const newData = await organizaData(responseFilter);

          setDataFilter(newData);
          setDataPdf(
            await organizaDataRelatorio(response.faturamentos, newData)
          );
        } catch (error) {
          setObjSnackBar({
            type: "error",
            msg: error.response.data.mensagem,
          });
        }
      } else {
        const newData = await organizaData(data);
        const dadosPdf = await organizaDataRelatorio(data, newData);

        setDataFilter(newData);
        setDataPdf(dadosPdf);
      }
    } else {
      setObjSnackBar({
        type: "error",
        msg: "Antes de filtrar, selecione o grupo econômico.",
      });
    }
  };

  const handleCalculaIR = (valor, percentual, imposto) => {
    if (valor && percentual && imposto) {
      const calculo =
        Math.round(
          ((valor * (percentual / 100)) / ((100 - imposto) / 100)) *
            (1.5 / 100) *
            100
        ) / 100;
      return calculo < 10 ? 0 : formatValue("number", calculo);
    } else {
      return 0;
    }
  };

  const handleCalculaBoleto = (vlHonorario, ir, cofins, csll) => {
    const VH = isNaN(Number(vlHonorario)) ? 0 : Number(vlHonorario);
    const IR = isNaN(Number(ir)) ? 0 : Number(ir);
    const CF = isNaN(Number(cofins)) ? 0 : Number(cofins);
    const CL = isNaN(Number(csll)) ? 0 : Number(csll);

    const calculo = VH - IR - CF - CL;
    return formatValue("number", calculo);
  };

  const organizaData = (data) => {
    const newData = data.map((item) => ({
      // idGrupoEconomico: item.idGrupoEconomico,
      // NomeGrupoEconomico: item.grupoEconomico,
      cnpj: formatValue("cnpj", item.cnpj),
      servico: item.servico,
      dtFatura: formatValue("data", item.dtFatura),
      percentualHonorarios: `${formatValue(
        "number",
        item.percentualHonorarios
      )} %`,
      imposto: `${formatValue("number", item.imposto)} %`,
      vlFatura: `R$ ${formatValue("number", item.valorFatura)}`,
      vlFinalHonorario: `R$ ${formatValue("number", item.valorFinalHonorario)}`,
      vlIr: `R$ ${handleCalculaIR(
        item.valorFatura,
        item.percentualHonorarios,
        item.imposto
      )}`,
      PisCofins: `R$ ${formatValue(
        "number",
        (parseInt(item.valorCofins) || 0) + (parseInt(item.valorPis) || 0)
      )}`,
      valorCsll: `R$ ${formatValue("number", item.valorCsll)}`,
      Boleto: `R$ ${handleCalculaBoleto(
        item.valorFinalHonorario,
        item.valorIR,
        item.valorCofins,
        item.valorCsll
      )}`,
      historicoFatura: item.historicoFatura,
    }));

    return newData;
  };

  const organizaDataRelatorio = async (inicialData, newData) => {
    return Promise.all(
      newData.map(async (newItem) => {
        const matchingItem = inicialData.find(
           (inicialItem) =>
            ( formatValue("cnpj", inicialItem.cnpj)) === newItem.cnpj
        );

        return {
          ...newItem,
          ...(matchingItem && {
            idEmpresa: matchingItem.idEmpresa,
            grupoEconomico: matchingItem.grupoEconomico,
            razaoSocial: matchingItem.razaoSocial,
          }),
        };
      })
    );
  };

  useEffect(() => {
    const montaData = async () => {
      const response = await getData(gpEEmpresa.grupoSelecionado);

      if (response?.faturamentos) {
        const responseOrganizada = await organizaData(response.faturamentos);

        const dadosPdf = await organizaDataRelatorio(
          response.faturamentos,
          responseOrganizada
        );

        setData(response.faturamentos);
        setDataFilter(responseOrganizada);
        setDataPdf(dadosPdf);
      } else {
        setObjSnackBar({
          type: "error",
          msg: "Erro ao buscar dados de faturamento",
        });
      }
    };

    if (gpEEmpresa.grupoSelecionado) {
      montaData();
    } else {
      setDataFilter([]);
      setDataPdf([]);
    }
  }, [gpEEmpresa.grupoSelecionado]);

  useEffect(() => {
    const atualizaData = async () => {
      const responseFiltrada = data.filter((item) =>
        gpEEmpresa.empresasSelecionadas.some((cnpj) => cnpj === item.cnpj)
      );

      setDataFilter(responseFiltrada);
      setDataPdf(await organizaDataRelatorio(data, responseFiltrada));
    };

    atualizaData();
  }, [gpEEmpresa.empresasSelecionadas]);

  const compareDatesIgnoringTime = (date1, date2) => {
    if (typeof date1 === "string" && date1.includes("/")) {
      const [day, month, year] = date1.split("/").map(Number);
      date1 = new Date(year, month - 1, day);
    }

    if (typeof date2 === "string") {
      date2 = new Date(date2);
    }

    const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

    if (d1.getTime() === d2.getTime()) {
      return 0;
    } else if (d1.getTime() > d2.getTime()) {
      return 1;
    } else {
      return -1;
    }
  };

  const applyDateRangeFilter = (data) => {
    let faturamentos = data;

    if (
      dateFilterInput.dtInicial &&
      dateFilterInput.dtInicial instanceof Date &&
      dateFilterInput.dtInicial !== null
    ) {
      faturamentos = data.filter((item) => {
        return (
          compareDatesIgnoringTime(item.dtFatura, dateFilterInput.dtInicial) >=
          0
        );
      });
    }

    if (
      dateFilterInput.dtFinal &&
      dateFilterInput.dtFinal instanceof Date &&
      dateFilterInput.dtFinal !== null
    ) {
      faturamentos = faturamentos.filter((item) => {
        return (
          compareDatesIgnoringTime(item.dtFatura, dateFilterInput.dtFinal) <= 0
        );
      });
    }

    return faturamentos;
  };

  const handleAtualizaComDataRange = async () => {
    if (filterBtn.label === "Filtrar") {
      if (gpEEmpresa.grupoSelecionado) {
        const newDataObj = await applyDateRangeFilter(dataFilter);

        if (newDataObj === dataFilter) {
          setObjSnackBar({
            type: "error",
            msg: "Range de data comtempla todos os dados ou campo não foi preenchido",
          });
        }
        setDataFilter(newDataObj);
        setDataPdf(await organizaDataRelatorio(data, newDataObj));
        setFilterBtn({ icon: <FilterAltOffIcon />, label: "Limpar Filtro" });
      } else {
        setObjSnackBar({
          type: "error",
          msg: "É necessário um grupo ecônomico selecionado",
        });
      }
    } else {
      setDateFilterInput(inicialStateDateFilter);
      const newData = await organizaData(data);
      setDataFilter(newData);
      setDataPdf(await organizaDataRelatorio(data, newData));
      setFilterBtn(inicialStateBtnFilter);
    }
  };

  const handleGrupoChange = (value) => {
    if (value) {
      const cnpjFilter = value.CNPJ.map((item) =>
        formatValue("cnpj", item.detalhes)
      );

      setGrupoEEmpresa({
        grupoSelecionado: value?.GE?.id,
        empresasSelecionadas: cnpjFilter,
      });
    } else {
      setGrupoEEmpresa(initialStategpEEmpresa);
    }
  };

  const styleDatePicker = {
    backgroundColor: "#fff",
    borderRadius: "8px",
    width: "200px",
  };

  const filter = [{value: "PIS COFINS"}, {value: "INSS"}];

  return (
    <>
      <ToolBar>
        <div className={styles.actions__bar}>
          <div className={styles.filterData__bar}>
            <GenericDatePicker
              label="Data inicial"
              fullwidth={false}
              sx={styleDatePicker}
              name="inicial"
              onChange={(value) => handleFiltrarPorData(value, "inicial")}
              value={dateFilterInput.dtInicial}
            />
            <GenericDatePicker
              label="Data final"
              fullwidth={false}
              sx={styleDatePicker}
              name="final"
              onChange={(value) => handleFiltrarPorData(value, "final")}
              value={dateFilterInput.dtFinal}
            />
            <button
              className={styles.btn__filterDate}
              onClick={handleAtualizaComDataRange}
            >
              {filterBtn.icon} <p>{filterBtn.label}</p>
            </button>
          </div>

          <div className={styles.extrator__bar}>
            <BtnExtratorRelatorio
              data={dataPdf}
              fileName={data[0]?.grupoEconomico}
            />
          </div>
        </div>
      </ToolBar>
      <div>
        <TableCard
          data={dataFilter}
          setData={setDataFilter}
          loading={loading}
          iconHeader={<TrendingUpIcon />}
          titleHeader="Faturamento"
          columns={columns}
          textHeaderCard="cnpj"
          handleDebounce={handleDebounce}
          handleGrupoEmpresa={handleGrupoChange}
          hasEmpresa
          selectedAllEpresas
          optionsFilter={filter}
        />
      </div>

      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={handleSnackBar} />
    </>
  );
};

export default Faturamento;
